import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { css } from 'aphrodite';
import shortid from 'shortid';
import qs from 'qs';

import Translatable from '../../../../../Translatable';
import SVGIcon from '../../../../../../components/SVGIcon';
import FullScreenPanel from './FullScreenPanel';
import MobileLocationInput from '../../SearchBarLarge/LocationInput/MobileLocationInput.jsx';
import MobileTagInput from '../../SearchBarLarge/TagInput/MobileTagInput.jsx';
import DateInput from '../../SearchBarLarge/DateInput';
import GuestInput from '../../GuestInput';

import styles from './styles.js';

import { escapeRegexCharacters } from '../../methods';

import {
    convertLocationStringToSlug,
    convertLocationSlugToString
} from '../../../../../../methods';

import {
    fetchActions,
    filterActions
} from '../../../../../../pages/Search/actions';

const AutosuggestHighlightMatch = require('autosuggest-highlight/match');
const AutosuggestHighlightParse = require('autosuggest-highlight/parse');

class SearchBarPanel extends Component {
    static propTypes = {
        apiUrl: PropTypes.string.isRequired,
        closePanel: PropTypes.func.isRequired,
        date: PropTypes.string.isRequired,
        defaultTags: PropTypes.array.isRequired,
        fetchSearchResultsAfterLocationChange: PropTypes.func.isRequired,
        fetchSearchResultsAfterSearchParamChange: PropTypes.func.isRequired,
        fetchSearchResultsAfterTagParamChange: PropTypes.func.isRequired,
        guests: PropTypes.number,
        location: PropTypes.string.isRequired,
        selectDate: PropTypes.func.isRequired,
        selectGuests: PropTypes.func.isRequired,
        selectLocation: PropTypes.func.isRequired,
        selectTag: PropTypes.func.isRequired,
        setTagLabel: PropTypes.func.isRequired,
        tagLabel: PropTypes.string,
        tags: PropTypes.array.isRequired,
        trackingCookieId: PropTypes.number.isRequired,
        userLang: PropTypes.string.isRequired
    }

    state = {
        children: null,
        fullScreenPanelVisible: false,
        dateInput: {
            visible: false,
            value: this.props.date
        },
        guestInput: {
            visible: false,
            value: this.props.guests
        },
        locationInput: {
            focus: false,
            focusedResultIndex: -1,
            results: [],
            value: this.props.location,
            visible: false
        },
        tagInput: {
            focus: false,
            focusedResultIndex: -1,
            visible: false,
            results: this.props.defaultTags,
            value: this.props.tagLabel
        },
        panelChildId: null
    }

    componentDidMount() {
        this.autoComplete = new google.maps.places.AutocompleteService();
        this.service = new google.maps.places.PlacesService(document.getElementById('placesService'));
    }

    handleClearAllFilters = () => {

    }

    displayLocationSuggestions = (predictions, status) => {
        if (status !== google.maps.places.PlacesServiceStatus.OK) {
            console.log(status);
            return;
        }
        const results = predictions.map((prediction, index) => (
            <li
                key={shortid.generate()}
                aria-selected="false"
                className={`location-result ${css(styles.result, styles.resultTall)}`}
                style={{ padding: '5px 10px' }}
                id={`location-result_${index}`}
                role="option"
                tabIndex="-1"
                data-location={prediction.description}
                data-place-id={prediction.place_id}
                onClick={this.handleLocationClick}
                onMouseEnter={this.handleResultMouseEnter}
                onMouseLeave={this.handleResultMouseLeave}
            >
                <div className={css(styles.textContainer)}>
                    <div className={css(styles.text)}>
                        {prediction.description}
                    </div>
                </div>
            </li>
        ));
        this.setState(prevState => ({
            locationInput: {
                ...prevState.locationInput,
                results
            }
        }));
    }

    onHandleGuestOptionClick = e => {
        this.props.selectGuests(e.target.dataset.value);
        this.setState(prevState => ({
            guestInput: {
                ...prevState.guestInput,
                visible: !prevState.guestInput.visible
            }
        }));
        this.props.fetchSearchResultsAfterSearchParamChange(
            this.props.apiUrl,
            this.props.userLang,
            {
                paramSlug: 'guests',
                paramValue: e.target.dataset.value
            },
            this.props.trackingCookieId
        );
        this.toggleFullScreenPanel();
    }

    onHandleHideDateInput = formattedDate => {
        setTimeout(() => {
            this.props.selectDate(formattedDate);
            this.props.fetchSearchResultsAfterSearchParamChange(
                this.props.apiUrl,
                this.props.userLang,
                {
                    paramSlug: 'date',
                    paramValue: formattedDate
                },
                this.props.trackingCookieId
            );
        }, 100);
        this.toggleFullScreenPanel();
    }

    onHandleHideGuestPanel = () => {
        this.setState((prevState) => ({
            guestInput: {
                ...prevState.guestInput,
                visible: false
            }
        }));
    }

    handleHideLocationInput = () => {
        this.setState((prevState) => ({
            locationInput: {
                ...prevState.locationInput,
                visible: false
            }
        }));
    }

    handleHideTagInput = () => {
        this.setState((prevState) => ({
            tagInput: {
                ...prevState.tagInput,
                visible: false
            }
        }));
    }

    handleLocationClick = e => {
        this.selectLocation(e.target.dataset.location, e.target.dataset.placeId);
    }

    onHandleShowDateInput = () => {
        this.setState(prevState => ({
            dateInput: {
                ...prevState.dateInput,
                visible: true
            }
        }));
    }

    handleShowLocationInput = () => {
        this.setState((prevState) => ({
            locationInput: {
                ...prevState.locationInput,
                visible: true
            }
        }));
    }

    handleShowTagInput = () => {
        this.setState(prevState => ({
            tagInput: {
                ...prevState.tagInput,
                visible: true
            }
        }));
    }

    handleTagClick = (e, { suggestion }) => {
        this.selectTag(suggestion);
    }

    handleShowLocationInput = () => {
        this.setState(prevState => ({
            locationInput: {
                ...prevState.locationInput,
                visible: true
            }
        }));
    }

    onPanelClose = () => {
        this.setState({
            panelChild: null
        });
    }

    selectTag = tag => {
        this.setState(prevState => ({
            tagInput: {
                ...prevState.tagInput,
                visible: false
            }
        }));
        this.props.selectTag(tag);
        this.props.setTagLabel(tag.label);
        this.props.fetchSearchResultsAfterTagParamChange(
            this.props.apiUrl,
            this.props.userLang,
            tag,
            this.props.trackingCookieId
        );
        this.handleHideTagInput();
        this.toggleFullScreenPanel();
    }

    selectLocation = (location, placeId) => {
        this.setState(prevState => ({
            locationInput: {
                ...prevState.locationInput,
                focusedResultIndex: -1,
                value: location
            }
        }));
        const locationSlug = convertLocationStringToSlug(location);
        this.service.getDetails({
            placeId
        }, (place, status) => {
            if (status && place) {
                const lat = place.geometry.location.lat();
                const lng = place.geometry.location.lng();
                this.props.fetchSearchResultsAfterLocationChange(
                    this.props.apiUrl,
                    this.props.userLang,
                    locationSlug,
                    lat,
                    lng,
                    this.props.trackingCookieId
                );
            }
        });
        this.props.selectLocation(locationSlug);
        this.handleHideLocationInput();
        this.toggleFullScreenPanel();
    }

    handleSetFilterPanel = e => {
        switch (Number(e.target.dataset.filter)) {
        case 1: {
            this.setState({
                panelChildId: 1
            });
            break;
        }
        case 2: {
            this.setState({
                panelChildId: 2
            });
            break;
        }
        case 3: {
            this.setState({
                panelChildId: 3
            });
            break;
        }
        case 4: {
            this.setState({
                panelChildId: 4
            });
            break;
        }
        }
        this.toggleFullScreenPanel();
    }

    toggleFullScreenPanel = () => {
        this.setState(prevState => ({ fullScreenPanelVisible: !prevState.fullScreenPanelVisible }));
    }

    toggleGuestPanel = () => {
        this.setState(prevState => ({
            guestInput: {
                ...prevState.guestInput,
                visible: !prevState.guestInput.visible
            }
        }));
    }

    onTagChange = (event, { newValue }) => {
        this.props.setTagLabel(newValue);
        this.setState(prevState => ({
            tagInput: {
                ...prevState.tagInput,
                value: newValue
            }
        }));
    }

    onSuggestionsFetchRequested = ({ value }) => {
        this.setState(prevState => ({
            tagInput: {
                ...prevState.tagInput,
                results: this.getSuggestions(value)
            }
        }));
    }

    onSuggestionsClearRequested = () => {
        this.setState(prevState => ({
            tagInput: {
                ...prevState.tagInput,
                results: this.props.defaultTags
            }
        }));
    }

    getSuggestions = value => {
        if (value) {
            const escapedValue = escapeRegexCharacters(value.trim());

            if (escapedValue === '') {
                return [];
            }
            const inputLength = escapedValue.length;

            return inputLength === 0 ? [] : this.props.tags.filter(item =>
                item.label.toLowerCase().slice(0, inputLength) === escapedValue
            );
        }
        return this.props.defaultTags;
    }

    getSuggestionValue = suggestion => {
        return `${suggestion.label}`;
    }

    renderSuggestion = (suggestion, { query }) => {
        const matches = AutosuggestHighlightMatch(suggestion, query);
        const parts = AutosuggestHighlightParse(suggestion, matches);
        return (
            <span className={css(styles.textContainer)}>
                <span className={css(styles.text)}>
                    {
                        parts.map(part => {
                            const style = part.highlight ? { color: '#00c8ff' } : {};
                            return (
                                <span
                                    style={style}
                                    key={shortid.generate()}
                                >
                                    {part.text.label}
                                </span>
                            );
                        })
                    }
                </span>
            </span>
        );
    }

    onHandleLocationChange = e => {
        const value = e.target.value;
        if (value !== '') {
            this.autoComplete.getPlacePredictions({
                input: value
            }, this.displayLocationSuggestions);
        }
        this.setLocationValue(value);
    }

    setLocationValue = value => {
        this.setState(prevState => ({
            locationInput: {
                ...prevState.locationInput,
                value
            }
        }));
    }

    render() {
        return (
            <div>
                <div className={css(styles.container)}>
                    <div
                        className={css(styles.container, styles.container_dropdown)}
                        aria-hidden="true"
                        onClick={this.props.closePanel}
                    />
                    <div className={css(styles.panel)}>
                        <div className={css(styles.panelContent)}>
                            <div className={css(styles.innerContainer)}>
                                <div className={css(styles.left)}>
                                    <button
                                        type="button"
                                        className={css(styles.buttonContainer)}
                                        aria-expanded="false"
                                        onClick={this.props.closePanel}
                                    >
                                        <SVGIcon
                                            type="cross"
                                        />
                                    </button>
                                </div>
                                <div className={css(styles.right)}>
                                    <div className={css(styles.text)}>
                                        <button
                                            type="button"
                                            className={css(styles.componentButton)}
                                            aria-disabled="false"
                                            onClick={this.handleClearAllFilters}
                                        >
                                            <Translatable
                                                content={{
                                                    transKey: 'search.clear_all'
                                                }}
                                            />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className={css(styles.body)}>
                                <button
                                    type="button"
                                    className={css(styles.button)}
                                    data-filter={1}
                                    onClick={this.handleSetFilterPanel}
                                >
                                    <span className={css(styles.copy)}>
                                        {
                                            this.state.tagInput.value ?
                                                <span>
                                                    {this.state.tagInput.value}
                                                </span> :
                                                <Translatable
                                                    content={{
                                                        transKey: 'common.what'
                                                    }}
                                                />
                                        }
                                    </span>
                                </button>
                                <div
                                    style={{
                                        marginTop: '16px'
                                    }}
                                >
                                    <button
                                        type="button"
                                        className={css(styles.button)}
                                        data-filter={2}
                                        onClick={this.handleSetFilterPanel}
                                    >
                                        <span className={css(styles.icon)}>
                                            <SVGIcon
                                                type="location-pin"
                                            />
                                        </span>
                                        <span className={css(styles.copy)}>
                                            <span
                                                style={{
                                                    pointerEvents: 'none'
                                                }}
                                            >
                                                {
                                                    this.props.location ?
                                                        <span>
                                                            {convertLocationSlugToString(this.props.location)}
                                                        </span> :
                                                        <Translatable
                                                            content={{
                                                                transKey: 'common.where'
                                                            }}
                                                        />
                                                }
                                            </span>
                                        </span>
                                    </button>
                                </div>
                                <div
                                    style={{
                                        marginTop: '16px'
                                    }}
                                >
                                    <button
                                        type="button"
                                        className={css(styles.button)}
                                        data-filter={3}
                                        onClick={this.handleSetFilterPanel}
                                    >
                                        <span className={css(styles.icon)}>
                                            <SVGIcon
                                                type="calendar"
                                            />
                                        </span>
                                        <span className={css(styles.copy)}>
                                            {
                                                this.props.date ?
                                                    this.props.date :
                                                    <Translatable
                                                        content={{
                                                            transKey: 'common.when'
                                                        }}
                                                    />
                                            }
                                        </span>
                                    </button>
                                </div>
                                <div
                                    style={{
                                        marginTop: '16px'
                                    }}
                                >
                                    <button
                                        type="button"
                                        className={css(styles.button)}
                                        data-filter={4}
                                        onClick={this.handleSetFilterPanel}
                                    >
                                        <span className={css(styles.icon)}>
                                            <SVGIcon
                                                type="people"
                                            />
                                        </span>
                                        <span className={css(styles.copy)}>
                                            {
                                                this.props.guests ?
                                                    <Translatable
                                                        content={{
                                                            transKey: 'common.guests_count',
                                                            count: this.props.guests,
                                                            replacements: {
                                                                number: this.props.guests
                                                            }
                                                        }}
                                                    /> :
                                                    <Translatable
                                                        content={{
                                                            transKey: 'common.any'
                                                        }}
                                                    />
                                            }
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    this.state.fullScreenPanelVisible ?
                        <FullScreenPanel
                            onClose={this.onPanelClose}
                            toggleFullScreenPanel={this.toggleFullScreenPanel}
                        >
                            {
                                this.state.panelChildId === 1 ?
                                    <MobileTagInput
                                        disableOnClickOutside={!this.state.tagInput.visible}
                                        getSuggestionValue={this.getSuggestionValue}
                                        handleHideTagInput={this.handleHideTagInput}
                                        handleShowTagInput={this.handleShowTagInput}
                                        lang={this.props.lang}
                                        isMobile
                                        onTagChange={this.onTagChange}
                                        onSuggestionSelected={this.handleTagClick}
                                        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                                        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                                        renderSuggestion={this.renderSuggestion}
                                        suggestions={this.state.tagInput.results}
                                        tagInput={this.state.tagInput}
                                        tagLabel={this.props.tagLabel}
                                    /> : null
                            }
                            {
                                this.state.panelChildId === 2 ?
                                    <MobileLocationInput
                                        lang={this.props.lang}
                                        handleLocationChange={this.onHandleLocationChange}
                                        locationInput={this.state.locationInput}
                                    /> : null
                            }
                            {
                                this.state.panelChildId === 3 ?
                                    <DateInput
                                        apiUrl={this.props.apiUrl}
                                        date={this.props.date}
                                        dateInput={this.state.dateInput}
                                        disableOnClickOutside={!this.state.dateInput.visible}
                                        fetchSearchResultsAfterSearchParamChange={this.props.fetchSearchResultsAfterSearchParamChange}
                                        handleHideDateInput={this.onHandleHideDateInput}
                                        handleShowDateInput={this.onHandleShowDateInput}
                                        idSuffix="Small"
                                        isMobile
                                        lang={this.props.lang}
                                        closePanel={this.props.closePanel}
                                        selectDate={this.props.selectDate}
                                        trackingCookieId={this.props.trackingCookieId}
                                        userLang={this.props.userLang}
                                    /> : null
                            }
                            {
                                this.state.panelChildId === 4 ?
                                    <GuestInput
                                        disableOnClickOutside={!this.state.guestInput.visible}
                                        handleHideGuestPanel={this.onHandleHideGuestPanel}
                                        guests={this.props.guests}
                                        handleClick={this.onHandleGuestOptionClick}
                                        lang={this.props.lang}
                                        handleToggleGuestPanel={this.toggleGuestPanel}
                                        guestPanelOpen={this.state.guestInput.visible}
                                    /> : null
                            }
                        </FullScreenPanel> : null
                }
            </div>
        );
    }
}

const mapStateToProps = state => ({
    apiUrl: state.config.apiUrl,
    defaultTags: state.tags.defaultTags,
    tags: state.tags.tags,
    filterGroupCollections: state.verticals.find(vert =>
        Number(vert.id) === Number(state.activeVerticalId)).filterGroupCollections,
    locationValue: state.searchParams.location,
    trackingCookieId: state.config.trackingCookieId,
    userLang: state.config.userLang
});

const mapDispatchToProps = dispatch => {
    return {
        fetchSearchResultsAfterSearchParamChange: (apiUrl, userLang, paramObj, trackingCookieId) => {
            const location = decodeURIComponent(window.location.pathname.split('/')[4]);
            const tag = {
                quick_slug: decodeURIComponent(window.location.pathname.split('/')[3])
            };
            const params = window.location.search.split('?')[1];
            const paramsObj = qs.parse(params);
            delete paramsObj.page;
            paramsObj[paramObj.paramSlug] = paramObj.paramValue;
            dispatch(fetchActions.fetchSearchResults(apiUrl, userLang, location, tag, qs.stringify(paramsObj), trackingCookieId, true));
        },
        fetchSearchResultsAfterTagParamChange: (apiUrl, userLang, tag, trackingCookieId) => {
            const location = decodeURIComponent(window.location.pathname.split('/')[4]);
            const params = window.location.search.split('?')[1];
            const paramsObj = qs.parse(params);
            delete paramsObj.page;
            dispatch(fetchActions.fetchSearchResults(apiUrl, userLang, location, tag, qs.stringify(paramsObj), trackingCookieId, true));
        },
        fetchSearchResultsAfterLocationChange: (apiUrl, userLang, location, lat, lng, trackingCookieId) => {
            const tag = {
                quick_slug: decodeURIComponent(window.location.pathname.split('/')[3])
            };
            const params = window.location.search.split('?')[1];
            const paramsObj = qs.parse(params);
            paramsObj.lat = lat;
            paramsObj.lon = lng;
            delete paramsObj.ne_lat;
            delete paramsObj.ne_lon;
            delete paramsObj.sw_lat;
            delete paramsObj.sw_lon;
            delete paramsObj.page;
            dispatch(fetchActions.fetchSearchResults(apiUrl, userLang, location, tag, qs.stringify(paramsObj), trackingCookieId, true, true));
        },
        selectDate: value =>
            dispatch(filterActions.selectDate(value)),
        selectTag: tag =>
            dispatch(filterActions.selectTag(tag)),
        selectGuests: value =>
            dispatch(filterActions.selectGuests(value)),
        selectLocation: value =>
            dispatch(filterActions.selectLocation(value)),
        setTagLabel: tagLabel =>
            dispatch(filterActions.setTagLabel(tagLabel))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchBarPanel);



// WEBPACK FOOTER //
// ./src/components/Header/MoveableDiv/SearchBar/SearchBarSmall/SearchBarPanel/SearchBarPanel.jsx